import { useState } from "react";
import { IUserDetailsInfo } from "../../interface/IUserDetails";
import { GET_CONTACT_DETAILS_ROUTE } from "@api-routes";
import { getResponseToState, IUserContactResponse } from "../mappers/getUserDetailsMapper";
import { useFetch } from "@common/hook/useFetch";

export const useGetUserContact = () => {
    const [userDetails, setUserDetails] = useState<IUserDetailsInfo>();
    const [getUserDetailsState, { get }] = useFetch();

    const getUserDetails = () => {
        get<IUserContactResponse>(GET_CONTACT_DETAILS_ROUTE).then((userContactResponse) => {
            if (userContactResponse) {
                setUserDetails(getResponseToState(userContactResponse));
            }
        });
    };

    return { userDetails, getUserDetailsState, getUserDetails };
};
